import { Spacing } from '@persona-id/design-tokens';
import { PlusIcon } from '@persona-id/design-tokens/icons';
import styled from 'styled-components';

import InactiveEnvironmentBanner from 'dashboard/components/InactiveEnvironmentBanner';
import { Container, Header, Section } from 'dashboard/layouts/IndexViewLayoutV2';
import { SortParams } from 'dashboard/lib/interfaces/SortParams';
import { InsightQuery } from 'dashboard/models/insight-queries';
import InsightQueriesTable from 'dashboard/views/DashboardInsightQueriesView/InsightQueriesTable';
import Button from 'design-system/components/Button';
import Card from 'design-system/components/Card/Card';
import Sticker from 'design-system/components/Sticker';
import Tooltip from 'design-system/components/Tooltip';

const ButtonGroup = styled('div')`
  display: flex;
  grid-column-start: 4;
  justify-content: flex-end;

  > * + * {
    margin-left: ${Spacing[3]};
  }
`;

export interface DashboardInsightQueriesViewProps {
  insightQueries: InsightQuery[];
  loading: boolean;
  handleRedirectToInsightQueryTool: () => void;
  handleArchiveInsightQuery: (id: string) => void;
}

const DashboardInsightQueriesView = ({
  insightQueries,
  loading,
  handleRedirectToInsightQueryTool,
  handleArchiveInsightQuery,
}: DashboardInsightQueriesViewProps) => {
  return (
    <Container>
      <InactiveEnvironmentBanner />
      <Header
        title='Insight Queries'
        append={
          <Tooltip
            trigger={
              <div style={{ marginLeft: '8px' }}>
                <Sticker variant='yellow'>BETA</Sticker>
              </div>
            }
          >
            This feature is in beta. Please don&apos;t rely on it for critical checks or automation.
            Please share your feedback with us.
          </Tooltip>
        }
      >
        <ButtonGroup>
          <Button
            id='insight-queries-view__create-inquiry-button'
            name='create-insight-query.button'
            data-test='insight-query-view__create-insight-querys-button'
            onClick={handleRedirectToInsightQueryTool}
            prefixIcon={<PlusIcon />}
            disabled={false}
          >
            New Query
          </Button>
        </ButtonGroup>
      </Header>
      <Section>
        <Card>
          <Card.Body>
            <Card.Title>Saved Queries</Card.Title>
            <InsightQueriesTable
              insightQueries={insightQueries}
              sortParams={{} as SortParams}
              canSort={insightQueries.length > 0}
              loading={loading}
              handleSortUpdate={() => {}}
              onArchiveClick={handleArchiveInsightQuery}
            />
          </Card.Body>
        </Card>
      </Section>
    </Container>
  );
};

export default DashboardInsightQueriesView;
